export default __webpack_public_path__ + "static/media/desktop_contrat_search.326001e8.svg";